import { type HandleType, makeIsAllowed } from '@kanda-libs/ks-component-ts';

import { YOUR_INFO_CLASS_NAMES, YOUR_INFO_FIELDS } from '../constants';

export const PROPS = {
  title: {
    text: 'Bank Account',
    className: YOUR_INFO_CLASS_NAMES.title,
  },
  description: {
    text: 'This is the bank account your direct debit will be taken from',
    className: 'text-style-g text-neutral-700 mb-6 -mt-4',
  },
  sortCode: {
    name: 'bank_account.sort_code',
    label: 'Bank sort code',
    placeholder: 'Bank sort code',
  },
  confirmAccount: {
    name: YOUR_INFO_FIELDS.CONFIRM_ACCOUNT,
    handle: 'checkbox' as HandleType,
    fieldText:
      'Please Confirm the account is in your name and you are an authorised signatory who is able to authorise this Direct Debit',
  },
  accountYearsOwned: {
    name: 'bank_account.years_owned',
    label: '',
    placeholder: 'Years',
    isAllowed: makeIsAllowed(0, 100),
  },
  accountMonthsOwned: {
    name: 'bank_account.months_owned',
    label: '',
    placeholder: 'Months',
    isAllowed: makeIsAllowed(0, 11),
  },
  iva: {
    name: YOUR_INFO_FIELDS.BANKRUPTCY_IVA,
    handle: 'checkbox' as HandleType,
    fieldText: 'I have not had an IVA or been bankrupt in the last 5 years.',
    validation: {
      required: {
        value: true,
        message: 'You must select an option',
      },
    },
  },
  card: {
    className:
      'flex flex-col md:px-4 md:pt-4 md:border border-neutral-300 rounded mb-4',
  },
};

export const CONFIRM_ACCOUNT_VALIDATION = {
  required: {
    value: true,
    message: 'You must confirm the above bank account is in your name',
  },
};

export const ERROR_PROPS = {
  label: 'You must provide the amount of time you have held this account for',
  className: 'text-style-h text-red-200 -mt-4 mb-6',
};

export const ACCOUNT_NUMBER_VALIDATION = {
  minLength: {
    value: 1,
    message: 'Account Number requires minimum length of 1',
  },
  pattern: {
    value: /^[0-9]{8}$/,
    message:
      'Account Number must be 8 digits. If your account number is less than 8 digits long please add a 0 at the start.',
  },
  required: { value: true, message: 'Account Number is required.' },
};
